import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import LogoutRoundedIcon from '@mui/icons-material/LogoutRounded';
import MenuContent from './MenuContent';
import { useUser } from '../../lib/auth-client';
import { authClient } from '../../lib/auth-client';
import { FacultyFilter } from '../Filters';

const drawerWidth = 240;

const Drawer = styled(MuiDrawer)({
	width: drawerWidth,
	flexShrink: 0,
	boxSizing: 'border-box',
	mt: 10,
	[`& .${drawerClasses.paper}`]: {
		width: drawerWidth,
		boxSizing: 'border-box',
	},
});

export default function SideMenu() {
	const { user } = useUser();

	const handleLogout = async () => {
		try {
			await authClient.signOut();
		} catch (error) {
			console.error('Logout failed:', error);
		}
	};

	return (
		<Drawer
			variant="permanent"
			sx={{
				display: { xs: 'none', md: 'block' },
				[`& .${drawerClasses.paper}`]: {
					backgroundColor: 'background.paper',
					position: 'fixed',
					height: '100vh',
					top: 0,
					left: 0,
				},
			}}
		>
			<Box
				onClick={() =>
					(window.location.href = '/')
				}
				sx={{
					display: 'flex',
					mt: 2,
					p: 1.5,
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Typography variant="h6" color="primary" fontWeight="bold">
					Quản lý thông tin tuyển sinh
				</Typography>
			</Box>
			<Divider />
			<FacultyFilter />
			<Divider />
			<Box
				sx={{
					overflow: 'auto',
					height: '100%',
					display: 'flex',
					flexDirection: 'column',
				}}
			>
				<MenuContent />
			</Box>
			<Stack
				direction="row"
				sx={{
					p: 2,
					gap: 1,
					alignItems: 'center',
					borderTop: '1px solid',
					borderColor: 'divider',
				}}
			>
				<Avatar
					sizes="small"
					alt={user?.name || 'User'}
					sx={{ width: 36, height: 36, bgcolor: 'primary.main' }}
				>
					{user?.name?.charAt(0).toUpperCase() || 'U'}
				</Avatar>
				<Box sx={{ mr: 'auto' }}>
					<Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
						{user?.name || 'Unknown User'}
					</Typography>
					<Typography variant="caption" sx={{ color: 'text.secondary' }}>
						{user?.username || 'No username'}
					</Typography>
					{user?.role && (
						<Typography variant="caption" sx={{ color: 'primary.main', display: 'block' }}>
							{user.role === 'admin' ? 'Quản trị viên' : 'Người dùng'}
						</Typography>
					)}
				</Box>
				<IconButton
					size="small"
					onClick={handleLogout}
					sx={{ color: 'text.secondary' }}
					title="Đăng xuất"
				>
					<LogoutRoundedIcon />
				</IconButton>
			</Stack>
		</Drawer>
	);
}